import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  AlertController,
  Events,
  IonicPage,
  NavController,
  NavParams,
  Slides,
} from "ionic-angular";
import { User } from "../../providers";
import { ListMasterPage } from "../list-master/list-master";
import { TrainingsPage } from "../trainings/trainings";

@IonicPage()
@Component({
  selector: "page-training-detail",
  templateUrl: "training-detail.html",
})
export class TrainingDetailPage implements OnInit {
  training: any;
  showBlankState = false;
  slides: any = [];
  currentSlideIndex = 0;

  @ViewChild(Slides) slideElement: Slides;

  get automaticMode(): boolean {
    return localStorage.getItem("trainingAutomaticMode") === "true";
  }

  handleAutomaticModeChange($event) {
    localStorage.setItem("trainingAutomaticMode", $event.value.toString());
  }

  constructor(
    private _navCtrl: NavController,
    private _user: User,
    private _navParams: NavParams,
    private _alertController: AlertController,
    private _translateService: TranslateService,
    private _tabEvents: Events
  ) {}

  ngOnInit() {
    this._user
      .getTrainingDetails(this._navParams.data.trainingId)
      .subscribe((result: any) => {
        this.training = result.data;
        let blockOrder = 0;
        let slideIndex = 0;
        for (const block of this.training.training.blocks) {
          block.currentSet = 0;
          this.slides.push({
            order: blockOrder,
            type: "block",
            lastSlide: false,
            currentStep: 0,
            data: {
              ...block,
            },
            slideIndex: slideIndex,
          });
          blockOrder++;
          slideIndex++;

          let stepOrder = 0;
          for (const step of block.steps) {
            this.slides.push({
              order: stepOrder,
              type: "step",
              lastSlide: false,
              parentBlock: block,
              data: {
                ...step,
              },
              slideIndex: slideIndex,
            });
            stepOrder++;
            slideIndex++;
          }
        }
        this.slides[this.slides.length - 1].lastSlide = true;

        setTimeout(() => {
          this.slideElement.onlyExternal = true;
          this.slideElement.initialSlide = 0;
        }, 300);
      });
  }
  handleNext() {
    if (this._isLastStepOnBlockAndPendingSets()) {
      console.log(
        "_isLastStepOnBlockAndPendingSets",
        this.slides[this.currentSlideIndex - 1]
      );
      this.slides[this.currentSlideIndex - 1].parentBlock.currentSet++;

      this.currentSlideIndex -=
        this.slides[this.currentSlideIndex - 1].parentBlock.steps.length - 1;
    } else {
      ++this.currentSlideIndex;
    }
    this.slideElement.slideTo(this.currentSlideIndex);
  }

  handlePrevious() {
    if (this.currentSlideIndex > 0) {
      --this.currentSlideIndex;
      this.slideElement.slideTo(this.currentSlideIndex);
    }
  }

  handleTrainingFinish() {
    this._user.finishTraining(this.training.id).subscribe(() => {
      this._navCtrl.push(ListMasterPage);
      this._tabEvents.publish("trainingNavigation", "masterListPage");
    });
  }

  handleCloseTraining() {
    const confirm = this._alertController.create({
      title: this._translateService.instant("CANCEL_TRAINING_ALERT_TITLE"),
      message: this._translateService.instant("CANCEL_TRAINING_ALERT_MESSAGE"),
      buttons: [
        {
          text: this._translateService.instant("NO"),
          handler: () => {},
        },
        {
          text: this._translateService.instant("YES"),
          handler: () => {
            this._navCtrl.push(TrainingsPage);
          },
        },
      ],
    });
    confirm.present();
  }

  private _isLastStepOnBlockAndPendingSets() {
    if (this.currentSlideIndex > 0) {
      const slideElement = this.slides[this.currentSlideIndex - 1];
      console.log(this.currentSlideIndex - 1, slideElement);
      if (slideElement.type === "step") {
        if (
          slideElement.order == slideElement.parentBlock.steps.length - 1 &&
          slideElement.parentBlock.currentSet <
            slideElement.parentBlock.nbSets - 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/training-detail/training-detail.ts